// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__kHpla","links":"Footer_links__xzRTV","watermark":"Footer_watermark__Gv6qU"};